/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 */

import { computeJobsListJobLogs } from "../../funcs/computeJobsListJobLogs.js";
import * as operations from "../../models/operations/index.js";
import { formatResult, ToolDefinition } from "../tools.js";

const args = {
  request: operations.ListJobLogsRequest$inboundSchema,
};

export const tool$computeJobsListJobLogs: ToolDefinition<typeof args> = {
  name: "compute-jobs-list-job-logs",
  description: `List job logs`,
  args,
  tool: async (client, args, ctx) => {
    const [result, apiCall] = await computeJobsListJobLogs(
      client,
      args.request,
      { fetchOptions: { signal: ctx.signal } },
    ).$inspect();

    if (!result.ok) {
      return {
        content: [{ type: "text", text: result.error.message }],
        isError: true,
      };
    }

    const value = result.value;

    return formatResult(value, apiCall);
  },
};
